import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "AIzaSyCRvUPGCdoi1fZGvtQRgMmJpOzHwKmgzkU",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "hospital-admin-panel-2ccee.firebaseapp.com",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "hospital-admin-panel-2ccee",
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "hospital-admin-panel-2ccee.firebasestorage.app",
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "960016641096",
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "1:960016641096:web:8acf2711768e92d452bc7d",
  measurementId: "G-VTHWPF5VS2"
};

const app = initializeApp(firebaseConfig);

let messaging = null;
if (typeof window !== 'undefined') {
  messaging = getMessaging(app);
}

export { messaging, getToken, onMessage };